<main class="admin-shell">
  <aside class="admin-sidebar">
    <div class="brand-block">
      <span>Frantinco</span>
      <strong>AI Content Admin</strong>
    </div>

    <nav class="admin-tabs" aria-label="Admin sections">
      <button type="button" [class.active]="activeTab === 'products'" (click)="setTab('products')">Products</button>
      <button type="button" [class.active]="activeTab === 'assets'" (click)="setTab('assets')">Assets</button>
      <button type="button" [class.active]="activeTab === 'documents'" (click)="setTab('documents')">Documents</button>
      <button type="button" [class.active]="activeTab === 'test'" (click)="setTab('test')">Test Chat</button>
      <button type="button" [class.active]="activeTab === 'recordings'" (click)="setTab('recordings')">Chat Logs</button>
      <button type="button" [class.active]="activeTab === 'missing'" (click)="setTab('missing')">Missing</button>
    </nav>
  </aside>

  <section class="admin-content">
    <header class="admin-header">
      <div>
        <h1>Chatbot Knowledge</h1>
        <p>Kelola data produk, thumbnail, link HIRES, dan cek pertanyaan yang belum terjawab.</p>
      </div>
      <button class="refresh-button" type="button" (click)="refreshAll()">Refresh</button>
    </header>

    <div class="summary-grid" *ngIf="summary">
      <div>
        <span>Products</span>
        <strong>{{ summary.products }}</strong>
      </div>
      <div>
        <span>Categories</span>
        <strong>{{ summary.categories }}</strong>
      </div>
      <div>
        <span>Series</span>
        <strong>{{ summary.series }}</strong>
      </div>
      <div>
        <span>With Assets</span>
        <strong>{{ summary.productsWithAssets }}</strong>
      </div>
      <div>
        <span>FAQ</span>
        <strong>{{ summary.faq }}</strong>
      </div>
      <div>
        <span>Articles</span>
        <strong>{{ summary.articleKnowledge }}</strong>
      </div>
      <div>
        <span>Areas</span>
        <strong>{{ summary.areaLocations }}</strong>
      </div>
      <div>
        <span>Missing</span>
        <strong>{{ summary.missingQuestions }}</strong>
      </div>
      <div>
        <span>Chat Logs</span>
        <strong>{{ summary.chatRecordings || 0 }}</strong>
      </div>
    </div>

    <p class="status-message" *ngIf="statusMessage">{{ statusMessage }}</p>

    <section class="panel-section" *ngIf="activeTab === 'products' || activeTab === 'assets'">
      <div class="toolbar">
        <input type="search" [(ngModel)]="search" (ngModelChange)="loadProducts(true)" placeholder="Cari kode, nama, kategori..." />
        <select [(ngModel)]="category" (ngModelChange)="series = ''; loadProducts(true)">
          <option value="">Semua kategori</option>
          <option *ngFor="let item of categories" [value]="item">{{ item }}</option>
        </select>
        <select [(ngModel)]="series" (ngModelChange)="loadProducts(true)" [disabled]="!category">
          <option value="">Semua series</option>
          <option *ngFor="let item of currentSeriesOptions" [value]="item">{{ item }}</option>
        </select>
      </div>

      <div class="content-grid">
        <div class="product-list">
          <div class="list-header">
            <strong>{{ totalProducts }} produk</strong>
            <span *ngIf="isLoadingProducts">Loading...</span>
          </div>

          <button
            class="product-row"
            type="button"
            *ngFor="let product of products"
            [class.selected]="selectedProduct?.code === product.code"
            (click)="selectProduct(product)"
          >
            <img *ngIf="product.thumbnailUrl" [src]="product.thumbnailUrl" [alt]="product.name" />
            <span class="thumb-fallback" *ngIf="!product.thumbnailUrl">{{ product.displayCode || product.code }}</span>
            <span>
              <strong>{{ product.displayCode || product.code }}</strong>
              <small>{{ product.name }}</small>
              <em>{{ product.category }} / {{ product.series }}</em>
            </span>
          </button>

          <div class="pager">
            <button type="button" (click)="previousPage()" [disabled]="!canGoPrevious">Prev</button>
            <button type="button" (click)="nextPage()" [disabled]="!canGoNext">Next</button>
          </div>
        </div>

        <form class="editor-panel" *ngIf="selectedProduct && activeTab === 'products'" (ngSubmit)="saveProduct()">
          <div class="editor-title">
            <div>
              <span>Edit Product</span>
              <strong>{{ selectedProduct.displayCode || selectedProduct.code }}</strong>
            </div>
            <button type="submit" [disabled]="isSaving">{{ isSaving ? 'Saving...' : 'Save' }}</button>
          </div>

          <label>
            Code
            <input [(ngModel)]="selectedProduct.code" name="code" />
          </label>
          <label>
            Name
            <input [(ngModel)]="selectedProduct.name" name="name" />
          </label>
          <div class="two-columns">
            <label>
              Category
              <input [(ngModel)]="selectedProduct.category" name="category" />
            </label>
            <label>
              Series
              <input [(ngModel)]="selectedProduct.series" name="series" />
            </label>
          </div>
          <div class="two-columns">
            <label>
              Dimension
              <input [(ngModel)]="selectedProduct.dimension" name="dimension" />
            </label>
            <label>
              Coverage
              <input [(ngModel)]="selectedProduct.coverage" name="coverage" />
            </label>
          </div>
          <label>
            Applications
            <input [(ngModel)]="applicationsText" name="applications" placeholder="wall, ceiling, furniture" />
          </label>
          <label>
            Description
            <textarea [(ngModel)]="selectedProduct.description" name="description" rows="7"></textarea>
          </label>
        </form>

        <form class="editor-panel" *ngIf="selectedProduct && activeTab === 'assets'" (ngSubmit)="saveAssets()">
          <div class="editor-title">
            <div>
              <span>Product Assets</span>
              <strong>{{ selectedProduct.displayCode || selectedProduct.code }}</strong>
            </div>
            <button type="submit" [disabled]="isSaving">{{ isSaving ? 'Saving...' : 'Save Assets' }}</button>
          </div>

          <div class="asset-preview">
            <img *ngIf="selectedProduct.thumbnailUrl" [src]="selectedProduct.thumbnailUrl" [alt]="selectedProduct.name" />
            <span *ngIf="!selectedProduct.thumbnailUrl">No thumbnail</span>
          </div>

          <label>
            Thumbnail URL
            <input [(ngModel)]="selectedProduct.thumbnailUrl" name="thumbnailUrl" placeholder="/product-thumbnails/fwpc-005.webp" />
          </label>
          <label>
            Download HIRES Google Drive URL
            <input [(ngModel)]="selectedProduct.hiresUrl" name="hiresUrl" placeholder="https://drive.google.com/file/d/.../view" />
          </label>
          <label>
            View 360 URL
            <input [(ngModel)]="selectedProduct.view360Url" name="view360Url" placeholder="https://www.720yun.com/t/..." />
          </label>
          <p class="helper-text">Thumbnail lokal paling cepat. Link Drive dan View 360 tampil sebagai tombol di kartu produk chat.</p>
        </form>
      </div>
    </section>

    <section class="panel-section test-section" *ngIf="activeTab === 'test'">
      <form class="test-form" (ngSubmit)="runChatTest()">
        <label>
          Pertanyaan test
          <textarea [(ngModel)]="testQuestion" name="testQuestion" rows="3"></textarea>
        </label>
        <button type="submit" [disabled]="isTesting">{{ isTesting ? 'Testing...' : 'Run Test' }}</button>
      </form>

      <pre class="test-output" *ngIf="testResponse">{{ testResponse }}</pre>
    </section>

    <section class="panel-section recordings-section" *ngIf="activeTab === 'recordings'">
      <div class="recording-header">
        <div>
          <strong>Chat Recording</strong>
          <span>
            {{ isChatRecordingEnabled ? 'Recording aktif' : 'Recording mati' }} /
            {{ filteredChatRecordingCount }} dari {{ chatRecordingCount }} chat
          </span>
        </div>
        <div class="recording-actions">
          <button
            type="button"
            class="record-toggle"
            [class.active]="isChatRecordingEnabled"
            (click)="toggleChatRecording()"
            [disabled]="isTogglingRecording"
          >
            {{ isChatRecordingEnabled ? 'Stop Recording' : 'Start Recording' }}
          </button>
          <button type="button" (click)="loadChatRecording()" [disabled]="isLoadingRecordings">Refresh</button>
          <button type="button" (click)="clearChatRecordings()" [disabled]="chatRecordingCount === 0 || isClearingRecordings">
            Clear Logs
          </button>
        </div>
      </div>

      <div class="recording-filter">
        <label>
          Dari tanggal
          <input type="date" [(ngModel)]="chatRecordingStartDate" name="chatRecordingStartDate" />
        </label>
        <label>
          Sampai tanggal
          <input type="date" [(ngModel)]="chatRecordingEndDate" name="chatRecordingEndDate" />
        </label>
        <div class="recording-filter-actions">
          <button
            type="button"
            class="filter-button"
            [class.active]="hasChatRecordingDateFilter"
            (click)="filterChatRecordings()"
          >
            Filter
          </button>
          <button
            type="button"
            class="shortcut-button"
            [class.active]="isChatRecordingShortcutActive(3)"
            (click)="useChatRecordingShortcut(3)"
          >
            3 hari
          </button>
          <button
            type="button"
            class="shortcut-button"
            [class.active]="isChatRecordingShortcutActive(7)"
            (click)="useChatRecordingShortcut(7)"
          >
            7 hari
          </button>
          <button
            type="button"
            class="reset-button"
            [class.active]="hasChatRecordingDateFilter"
            (click)="resetChatRecordingFilter()"
            [disabled]="!hasChatRecordingDateFilter"
          >
            Reset
          </button>
          <button
            type="button"
            class="export-button"
            (click)="exportChatRecordings()"
            [disabled]="filteredChatRecordingCount === 0"
          >
            Export Excel
          </button>
        </div>
      </div>

      <p class="helper-text">File log: {{ chatRecordingPath }}</p>

      <div class="recording-row" *ngFor="let item of chatRecordings">
        <div class="recording-meta">
          <strong>{{ item.source }}</strong>
          <span>{{ item.recordedAt }} / status {{ item.statusCode }}</span>
        </div>
        <div class="recording-qa">
          <span>Q</span>
          <p>{{ item.question }}</p>
        </div>
        <div class="recording-qa">
          <span>A</span>
          <p>{{ item.answer }}</p>
        </div>
        <small *ngIf="item.products.length || item.salesContacts.length">
          {{ item.products.length }} product card / {{ item.salesContacts.length }} sales card
        </small>
      </div>

      <p class="helper-text" *ngIf="chatRecordings.length === 0">Belum ada chat yang terekam.</p>
    </section>

    <section class="panel-section documents-section" *ngIf="activeTab === 'documents'">
      <div class="documents-header">
        <div>
          <strong>AnythingLLM Documents</strong>
          <span>{{ workspaceName || 'fran-chatbot' }} / {{ workspaceDocuments.length }} workspace docs</span>
        </div>
        <div class="documents-actions">
          <button class="sync-faq-button" type="button" (click)="syncFaqKnowledge()" [disabled]="isSyncingFaq">
            {{ isSyncingFaq ? 'Syncing FAQ...' : 'Sync FAQ Excel' }}
          </button>
          <button class="sync-faq-button" type="button" (click)="syncIndonesiaAreas()" [disabled]="isSyncingAreas">
            {{ isSyncingAreas ? 'Syncing Areas...' : 'Sync Area Indonesia' }}
          </button>
          <label class="upload-button">
            {{ isUploadingDocument ? 'Uploading...' : 'Upload Document' }}
            <input type="file" (change)="uploadDocument($event)" [disabled]="isUploadingDocument" />
          </label>
          <button type="button" (click)="loadDocuments()" [disabled]="isLoadingDocuments">Refresh</button>
        </div>
      </div>

      <div class="documents-grid">
        <div class="documents-panel">
          <div class="documents-panel-title">
            <strong>Workspace</strong>
            <span>Dipakai chatbot AnythingLLM</span>
          </div>

          <div class="document-row" *ngFor="let document of workspaceDocuments">
            <span class="document-icon">DOC</span>
            <span>
              <strong>{{ document.title || document.name }}</strong>
              <small>{{ document.docpath }}</small>
              <em>{{ document.wordCount || 0 }} words / {{ document.tokenCount || 0 }} tokens</em>
            </span>
            <button type="button" (click)="removeDocumentFromWorkspace(document)" [disabled]="isSyncingDocuments">
              Remove
            </button>
          </div>

          <p class="helper-text" *ngIf="workspaceDocuments.length === 0">Belum ada dokumen di workspace.</p>
        </div>

        <div class="documents-panel">
          <div class="documents-panel-title">
            <strong>Local Documents</strong>
            <span>Pilih dokumen lalu sync ke workspace</span>
          </div>

          <div class="document-toolbar">
            <input type="search" [(ngModel)]="documentSearch" placeholder="Cari dokumen AnythingLLM..." />
            <button type="button" (click)="syncSelectedDocuments()" [disabled]="selectedDocumentCount === 0 || isSyncingDocuments">
              Sync {{ selectedDocumentCount || '' }}
            </button>
          </div>

          <label class="document-row selectable" *ngFor="let document of filteredLocalDocuments">
            <input
              type="checkbox"
              [checked]="selectedDocumentPaths[document.docpath]"
              [disabled]="document.inWorkspace"
              (change)="toggleDocumentSelection(document, $any($event.target).checked)"
            />
            <span class="document-icon" [class.synced]="document.inWorkspace">{{ document.inWorkspace ? 'OK' : 'DOC' }}</span>
            <span>
              <strong>{{ document.title || document.name }}</strong>
              <small>{{ document.docpath }}</small>
              <em>{{ document.inWorkspace ? 'Sudah di workspace' : 'Belum sync' }}</em>
            </span>
          </label>
        </div>
      </div>
    </section>

    <section class="panel-section missing-section" *ngIf="activeTab === 'missing'">
      <div class="missing-header">
        <strong>Missing Questions</strong>
        <button type="button" (click)="clearMissingQuestions()" [disabled]="missingQuestions.length === 0">Clear</button>
      </div>

      <div class="missing-row" *ngFor="let item of missingQuestions">
        <strong>{{ item.message }}</strong>
        <span>{{ item.reason }} / {{ item.count }}x</span>
        <small>Last: {{ item.lastAskedAt }}</small>
      </div>

      <p class="helper-text" *ngIf="missingQuestions.length === 0">Belum ada pertanyaan yang masuk missing report.</p>
    </section>
  </section>
</main>
